import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table, Button, Space } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const CouponImportModal = ({
  isOpen,
  onClose,
  onImport,
  loading,
  fileData = [],
  importColumns = [],
}) => {
  return (
    <Modal
      title={
        <Space>
          <UploadOutlined />
          ตัวอย่างการนำเข้าคูปอง
        </Space>
      }
      open={isOpen}
      onCancel={onClose}
      footer={
        <Space>
          <Button onClick={onClose}>ยกเลิก</Button>
          <Button type='primary' onClick={onImport} loading={loading}>
            นำเข้า
          </Button>
        </Space>
      }
      width={900}
      centered
    >
      <div style={{ marginTop: '24px' }}>
        <Table
          columns={importColumns}
          dataSource={fileData}
          rowKey='coupon_id'
          pagination={false}
          scroll={{ y: 400 }}
        />
      </div>
    </Modal>
  );
};

CouponImportModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onImport: PropTypes.func,
  loading: PropTypes.bool,
  fileData: PropTypes.arrayOf(PropTypes.object),
  importColumns: PropTypes.arrayOf(PropTypes.object),
};

export default CouponImportModal;
